// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};



(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  
    var bindEvents = InstantSearchMobile.prototype.bindEvents;

    InstantSearchMobile.prototype.bindEvents = function() {
      bindEvents.call(this);

      var self = this;

      // Change here the class of your button
      jQ('.mobile-header-controls__search').click(function(e) {
        e.stopPropagation();
        e.preventDefault();
        self.openSuggestionMobile()
      });
    }
    InstantSearchMobile.prototype.afterShowSearchBoxMobile = function(){
      if(jQ(".predictive-search__close").length){
    	jQ(".predictive-search__close").trigger("click")
      }
    }
    
    Utils.reBuildUrlBaseOnLocale = function(url) {
        // remove http or https
        url = url.replace('https://', '').replace('http://', '');
        var currentLocale = Settings.getSettingValue('general.current_locale');
        var publishedLocales = Settings.getSettingValue('general.published_locales');
      	var publishedLocaleKeys = '';
        if (Object.values(publishedLocales).length > 0 && Object.values(publishedLocales)[0]) {
			publishedLocaleKeys = Object.keys(publishedLocales);
        }
        var currentLocaleIndex = publishedLocaleKeys.indexOf(currentLocale);

      // If the locale isnt in the published list, or is default locale, return the normal url
        if (currentLocaleIndex < 0 || publishedLocales[currentLocale] == true) return url;

        var urlArr = url.split('/');
      
        if (urlArr.length > 1 && publishedLocaleKeys.length && currentLocale.length) {
            var isUrlHasLocaleString = publishedLocaleKeys.indexOf(urlArr[1]) > -1;
            if (isUrlHasLocaleString) {
                urlArr[1] = currentLocale;
            } else {
                urlArr.splice(1, 0, currentLocale);
            }
        }

      	return urlArr.join('/');
    }
    
})();